export const pro_premier_pullover = {
  msrp: 59.99,
  variants: [['SHORT SLEEVE', 'LONG SLEEVE']],
  infoLink: 'https://www.teamtriton.com/pro-premier-pullover.html',
  items: [
    {
      number: 'PP100',
      hasModel: false,
    },
    {
      number: 'PP101',
      hasModel: false,
    },
    {
      number: 'PP102',
      hasModel: false,
    },
    {
      number: 'PP103',
      hasModel: false,
    },
    {
      number: 'PP104',
      hasModel: false,
    },
    {
      number: 'PP105',
      hasModel: false,
    },
    {
      number: 'PP106',
      hasModel: false,
    },
    {
      number: 'PP107',
      hasModel: false,
    },
    {
      number: 'PP108',
      hasModel: false,
    },
    {
      number: 'PP109',
      hasModel: false,
    },
    {
      number: 'PP110',
      hasModel: false,
    },
    {
      number: 'PP111',
      hasModel: false,
    },
    {
      number: 'PP112',
      hasModel: false,
    },
    {
      number: 'PP113',
      hasModel: false,
    },
    {
      number: 'PP114',
      hasModel: false,
    },
    {
      number: 'PP115',
      hasModel: false,
    },
  ],
};
